// **********************************************************
// Product Variation
// **********************************************************

// Populate variation data on single product page
const populateVariation = (data, popup) => {
  const productModule = document.querySelector('.product-module');
  const priceEle = (popup || productModule).querySelector(popup ? '.product-popup__price' : '.product-module__price');
  const oldPriceEle = (popup || productModule).querySelector(
    popup ? '.product-popup__price--old' : '.product-module__old-price',
  );
  const lowestPriceEle = document.querySelector(
    popup ? '.product-popup__lowest-price' : '.product-module__lowest-price',
  );

  priceEle.querySelector('p').innerHTML = data.prices.current_price;
  priceEle.dataset.currentPrice = data.prices.current_price_data;
  oldPriceEle.dataset.oldPrice = data.prices.old_price_data;

  if (data.prices.old_price) {
    oldPriceEle.innerHTML = popup ? data.prices.old_price : `<p><del>${data.prices.old_price}</del></p>`;
  } else {
    oldPriceEle.innerHTML = '';
  }

  (popup || productModule).querySelector('.variation-id').value = data.variation_id;

  const tempContainer = document.createElement('div');
  tempContainer.innerHTML = data.notify_input_html;
  const newNotifyInputEle = tempContainer.firstChild;
  const notifyInputEle = (popup || productModule).querySelector('.notify-input');
  const addToCartEle = document.querySelector(popup ? '.product-popup__add-to-cart' : '.product-module__add-to-cart');

  if (notifyInputEle && newNotifyInputEle) {
    notifyInputEle.replaceWith(newNotifyInputEle);
  }

  if (addToCartEle) {
    addToCartEle.classList.toggle('is-disabled', !data.is_in_stock);
    addToCartEle.querySelector('.btn').classList.toggle('btn--disabled', !data.is_in_stock);
    addToCartEle.querySelector('.btn__text').innerHTML = data.add_to_cart_btn_text;
  }

  if (lowestPriceEle) {
    lowestPriceEle.querySelector('p span').innerHTML = data.prices.lowest_price;
  }

  if (data.tag_list_html) {
    const tempTagContainer = document.createElement('div');
    tempTagContainer.innerHTML = data.tag_list_html;
    const [newTagListEle] = tempTagContainer.children;
    const productShowcaseEle = (popup || productModule).querySelector('.product-showcase__main-slider');
    const tagListEle = productShowcaseEle.querySelector('.tag-list');

    if (tagListEle) {
      tagListEle.replaceWith(newTagListEle);
    } else {
      productShowcaseEle.appendChild(newTagListEle);
    }
  }
};

// Get variation data axios
const axiosGetVariation = async (formData, popup) => {
  const formDataInput = new FormData();
  formDataInput.append('action', 'getProductVariation');
  formDataInput.append('inputs', JSON.stringify(formData));
  formDataInput.append('id', (popup || document).querySelector('.product-id').value);
  formDataInput.append(
    'personalization',
    (popup || document).querySelector('.personalization-input.is-open-data') ? 1 : 0,
  );

  const addToCartButton = document.querySelector(
    popup ? '.product-popup__add-to-cart .btn' : '.product-module__add-to-cart .btn',
  );
  if (addToCartButton) {
    addToCartButton.classList.add('is-loading');
  }

  try {
    const response = await axios.post(localData.apiURL, formDataInput);
    if (addToCartButton) {
      addToCartButton.classList.remove('is-loading');
    }
    populateVariation(response.data.data, popup);
  } catch (err) {
    console.error(err);
  }
};

// get variation selected attributes and call axiosGetVariation
const getVariation = (popup) => {
  const selectors = (popup || document).querySelectorAll('.size-selector, .radio-selector-group');
  const selectorsData = {};
  let isAnyInputNull = false;
  selectors.forEach((section) => {
    const inputField = section.querySelector('input:checked');
    if (inputField === null) {
      isAnyInputNull = true;
      return;
    }
    selectorsData[`attribute_${inputField.name.replace('popup-', '')}`] = inputField.value;
    section.classList.remove('is-validation-failed');
  });

  if (isAnyInputNull) {
    return;
  }

  axiosGetVariation(selectorsData, popup);
};

// set new active gallery image based on clicked protective cap
const setNewActiveImage = (popup, cap) => {
  const selectors = Array.from(document.querySelectorAll('.product-showcase__thumb-slider [data-cap]'));
  const indexToSlide = selectors.findIndex((section) => cap === section.dataset.cap);
  if (indexToSlide > -1) {
    document
      .querySelectorAll(
        '[data-slider="product-gallery-modal-main-slider"], [data-slider="product-gallery-modal-thumb-slider"], [data-slider="product-showcase-main"], [data-slider="product-showcase-thumb"]',
      )
      .forEach((item) => {
        const swiperInst = item.swiper;
        if (swiperInst) {
          swiperInst.slideTo(indexToSlide);
        }
      });
  }
};

// Click on single product radio selector
const listenToVariationChange = () => {
  const containerFilter = document.querySelectorAll('.modal-overlay, .product-module__inner');
  containerFilter.forEach((container) => {
    container
      .querySelectorAll(
        '.size-selector input, .product-module__right .radio-selector-group input, .product-popup__right .radio-selector-group input',
      )
      .forEach((item) => {
        item.addEventListener('click', () => {
          if (
            item.name !== 'size' &&
            item.name !== 'popup-size' &&
            item.name !== 'value' &&
            item.name !== 'popup-value'
          ) {
            item.closest('.radio-selector-group').querySelector('.radio-selector-group__title-text').innerHTML =
              item.dataset.text;
          }
          if (
            item.name === 'protective-cap' ||
            item.name === 'popup-protective-cap' ||
            item.name === 'sole' ||
            item.name === 'popup-sole'
          ) {
            setNewActiveImage(item.closest('.product-popup'), item.value);
          }
          getVariation(item.closest('.product-popup'));
        });
      });
  });
};

listenToVariationChange();

// **********************************************************
// Add to cart
// **********************************************************

// Open Cart Popup on add to cart success
const openCartPopupOnAddSuccess = (popupContent, popup = '') => {
  const cartPopup = document.querySelector('.cart-popup');
  if (cartPopup) {
    if (popup && popup.closest('.cart-popup')) {
      cartPopup.classList.remove('is-open-cart');
      document.querySelector('.cart-popup__close').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    const cartPopupContent = cartPopup.querySelector('.cart-popup__content');
    const isOpen = cartPopup.classList.contains('is-open-cart');
    cartPopupContent.innerHTML = popupContent;
    cartPopup.classList.remove('cart-popup--empty');
    cartPopup.classList.toggle('is-open-cart', !isOpen);
    toggleBodyScrollLock(!isOpen);
  }
};

// Add to cart axios
const axiosAddToCart = async (formData, formAction, popup) => {
  const nonce = 'nonce';
  const token = 'token';
  const formDataInput = new FormData();
  formDataInput.append('action', formAction);
  formDataInput.append('inputs', JSON.stringify(formData));
  formDataInput.append('nonce', nonce);
  formDataInput.append('token', token);

  try {
    const response = await axios.post(localData.apiURL, formDataInput, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    openCartPopupOnAddSuccess(response.data.data.cart_content_html, popup);
    updateCartNumber(response.data.data.cart_contents_count);
    // GTAG - add_to_cart event
    const dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push(response.data.data.add_to_cart);
    // GTAG - add_to_cart event
  } catch (err) {
    console.error(err);
  }
};

// Click on add to cart button
const handleAddToCartClick = (popup) => {
  // const personalizationEle = (popup || document).querySelector('.personalization-input');
  const personalizationValueEle = (popup || document).querySelector('.personalization-input__value');
  const quantityCounterEle = document.querySelector('#quantity-counter');
  const notesEle = document.querySelector(popup ? '#order-notes' : '.order-notes textarea');
  const voucherFormEle = (popup || document).querySelector('.product-module__gift-form');
  const voucherRecipientNameEle = document.querySelector('#gift-recipient-name');
  const voucherYourNameEle = document.querySelector('#gift-your-name');
  const voucherMessageEle = document.querySelector('#gift-message');

  if (document.querySelector('input[name="attribute_variation"]')) {
    const checked = document.querySelector('input[name="attribute_variation"]:checked');
    document.querySelector('.product-module__right .dropdown').classList.toggle('is-validation-failed', !checked);
    if (!checked) {
      return;
    }
    document.querySelector('.variation-id').value = checked.value;
  }
  if (voucherFormEle) {
    const errorMessages = [];
    const errorMessageEle = (popup || document).querySelector('.product-module__error-message');
    [voucherRecipientNameEle, voucherYourNameEle].forEach((element) => {
      if (!element.value) {
        errorMessages.push(`<p>${element.getAttribute('data-fv-not-empty___message')}</p>`);
      }
      element.closest('.mod-input').classList.toggle('is-validation-failed', !element.value);
    });

    errorMessageEle.innerHTML = errorMessages.length > 0 ? errorMessages.join('') : '';

    if (errorMessages.length > 0) {
      return;
    }
  }

  const variationIdEle = (popup || document).querySelector('.variation-id');
  let prodId = (popup || document).querySelector('.product-id');
  if (prodId) {
    prodId = prodId.value;
  } else {
    prodId = popup.dataset.productId;
  }
  const addToCartData = {
    product_id: prodId,
    variation_id: variationIdEle ? variationIdEle.value : 0,
    quantity: quantityCounterEle ? quantityCounterEle.value : 1,
    personalization: personalizationValueEle ? personalizationValueEle.innerHTML : '',
    note: notesEle ? notesEle.value : voucherMessageEle ? voucherMessageEle.value : '',
    voucher_recipient_name: voucherRecipientNameEle ? voucherRecipientNameEle.value : '',
    voucher_your_name: voucherYourNameEle ? voucherYourNameEle.value : '',
  };
  axiosAddToCart(addToCartData, 'addToCart', popup);
};

attachEvent(
  '.product-module__add-to-cart:not(.is-disabled) a:not(.is-loading),' +
    ' .product-popup__add-to-cart .btn:not(.btn--disabled):not(.is-loading)',
  'click',
  (ev) => {
    ev.preventDefault();
    handleAddToCartClick(ev.target.closest('.product-card') ?? ev.target.closest('.product-popup'));
  },
);

// **********************************************************
// Out of stock
// **********************************************************
// Stock notification Response
const stockNotificationResponse = (message, popup) => {
  (popup || document).querySelector('.notify-input').innerHTML = `<strong>${message}</strong>`;
};

// Add stock notification axios
const axiosAddStockNotification = async (formData, popup, notifyButton, formAction) => {
  notifyButton.classList.add('is-loading');
  const nonce = await getNonceForAction(formAction);

  grecaptcha.ready(async () => {
    const token = await grecaptcha.execute(localData.captchaSiteKey, { action: formAction });
    const formDataInput = new FormData();
    formDataInput.append('action', formAction);
    formDataInput.append('inputs', JSON.stringify(formData));
    formDataInput.append('nonce', nonce);
    formDataInput.append('token', token);

    try {
      const response = await axios.post(localData.siteURL, formDataInput);
      notifyButton.classList.remove('is-loading');
      stockNotificationResponse(response.data.data.message, popup);
    } catch (err) {
      stockNotificationResponse(err.response.data.data.error_message, popup);
    }
  });
};

// Add stock notification click
attachEvent('.notify-input .btn', 'click', (ev) => {
  ev.preventDefault();
  const parentEle = ev.target.closest('.notify-input');
  const emailAddress = parentEle.querySelector('input.mod-input__field').value.replace(/(<([^>]+)>)/gi, '');
  const emailReg = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
  const popupEle = ev.target.closest('.product-popup');

  if (emailAddress.length < 1) {
    return;
  }

  if (!emailReg.test(emailAddress)) {
    parentEle.classList.add('is-validation-failed');
    return;
  }

  parentEle.classList.remove('is-validation-failed');

  const notificationData = {
    product_id: (popupEle || document).querySelector('.product-id').value,
    variation_id: (popupEle || document).querySelector('.variation-id').value,
    email: emailAddress,
  };

  axiosAddStockNotification(notificationData, popupEle, parentEle.querySelector('.btn'), 'addStockNotification');
});
